<template>
  <report-layout :available-reports="$parent.availableReports" :openedReport="$parent.openedReport" close-path="/team/reports">
    <template v-slot:header>
      <div v-if="!$parent.loading">
        <h1 class="info-headline">{{$t('team-results:title-uwes')}}</h1>
        <h5><span>{{ $t('team-results:description-uwes') }}</span></h5>
      </div>
    </template>
    <div v-if="!$parent.loading">
      <b-container fluid class="pt-3 pb-5">
        <div v-if="$parent.currentEngagementReport.stats">
          <b-row align-v="center" align-h="center" class="mt-2">
            <b-col cols="12" sm="12" md="5" order-md="2">
              <b-row>
                <b-col>
                  <div class="overall-score">
                    <span class="--value">{{$parent.formatNumber0($parent.currentEngagementReport.stats['uwes9-total'].avg/6.0*100)}}</span>
                    <span class="--scale">/ 100</span>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="animated-bar">
                    <div class="meter" :class="{'activated': $parent.teamUWESPercent !== 0}" :style="{'background-color': $parent.mapColor($parent.currentEngagementReport.categories['uwes9-total']), 'width': $parent.teamUWESPercent}"></div>
                  </div>
                  <p class="tidbit">{{$t('common:updated')}} {{$parent.currentEngagementReport.updatedAt | moment('from')}}.</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" md="5" order-md="1">
              <h3 class="feedback-title">
                <span v-html="$t('work-engagement-snapshot:work-engagement-score', { workEngagementClassification: '$t(classification-'+$parent.currentEngagementReport.categories['uwes9-total']+')', workEngagementScore: $parent.formatNumber0($parent.currentEngagementReport.stats['uwes9-total'].avg/6.0*100) })"></span>
                <!-- <span>{{ $t('personal-results:total-classification-title-' + $parent.currentEngagementReport.categories['uwes9-total']) }}</span> -->
              </h3>
              <p><b-btn v-b-toggle.collapse1 variant="link" size="sm"><icon name="regular/lightbulb" style="margin-right: 0.5em;"/> {{$t('common:what-is-work-engagement')}}</b-btn></p>
            </b-col>
          </b-row>
          <b-row align-v="center" align-h="center">
            <b-col cols="12" md="12">
              <div>
                <b-collapse id="collapse1" class="mt-0">
                  <b-card>
                    <p>{{$t('common:description-personal-work-engagement')}}</p>
                  </b-card>
                </b-collapse>
              </div>
            </b-col>
          </b-row>

          <b-row align-v="center" align-h="center" class="mt-2">
            <b-col cols="12" sm="12" md="5" order-md="2" class="pt-3">
              <barchart :items="$parent.workEngagementItems"/>
            </b-col>
            <b-col cols="12" md="5" order-md="1" class="pt-3">
              <h3 class="feedback-title">
                <span v-if="$parent.currentEngagementReport.stats['uwes9-total'].max - $parent.currentEngagementReport.stats['uwes9-total'].min >= 4">
                  {{$t('work-engagement-snapshot:assessment-work-engagement-range-4')}}
                </span>
                <span v-else-if="$parent.currentEngagementReport.stats['uwes9-total'].max - $parent.currentEngagementReport.stats['uwes9-total'].min >= 3">
                  {{$t('work-engagement-snapshot:assessment-work-engagement-range-3')}}
                </span>
                <span v-else-if="$parent.currentEngagementReport.stats['uwes9-total'].max - $parent.currentEngagementReport.stats['uwes9-total'].min >= 2">
                  {{$t('work-engagement-snapshot:assessment-work-engagement-range-2')}}
                  </span>
                <span v-else-if="$parent.currentEngagementReport.stats['uwes9-total'].max - $parent.currentEngagementReport.stats['uwes9-total'].min >= 1">
                  {{$t('work-engagement-snapshot:assessment-work-engagement-range-1')}}
                </span>
                <span v-else-if="$parent.currentEngagementReport.stats['uwes9-total'].max - $parent.currentEngagementReport.stats['uwes9-total'].min > 0.5">
                  {{$t('work-engagement-snapshot:assessment-work-engagement-range-0_5')}}
                </span>
                <span v-else>
                  {{$t('work-engagement-snapshot:assessment-work-engagement-range-no')}}
                </span>
                <span v-html="$t('work-engagement-snapshot:assessment-work-engagement-range', { lowClassification: '$t(classification-'+$parent.currentEngagementReport.categories['uwes9-total-min']+')', lowScore: $parent.formatNumber0($parent.currentEngagementReport.stats['uwes9-total'].min/6.0*100), highClassification: '$t(classification-'+$parent.currentEngagementReport.categories['uwes9-total-max']+')', highScore: $parent.formatNumber0($parent.currentEngagementReport.stats['uwes9-total'].max/6.0*100) })"></span>
              </h3>
            </b-col>
          </b-row>
          <!-- <b-row v-if="$parent.engagementHistory" align-v="center" align-h="center" class="mt-2">
            <b-col cols="12" sm="12" md="5" order-md="2" class="pt-5">
              <svg :viewBox="'0 0 '+ Object.keys($parent.engagementHistory).length*150 +' 100'" preserveAspectRatio="none" style="width: 100%; max-width: 100%; height: 100px; background: #ffffff; border: 1px solid #fff; border-left-color: #ccc; border-bottom-color: #ccc;">
                <defs>
                  <path id="area" :d="getMinMaxArea('uwes9')"></path>
                  <linearGradient gradientUnits="userSpaceOnUse" id="gradient" y1="100" y2="0" x1="0" x2="0">
                    <stop :offset="Math.round(((0.00) / 6.0) * 100) + '%'" stop-color="#e63333" />
                    <stop :offset="Math.round(((1.77) / 6.0) * 100) + '%'" stop-color="#e63333" />
                    <stop :offset="Math.round(((1.77) / 6.0) * 100) + '%'" stop-color="#f39c9d" />
                    <stop :offset="Math.round(((2.88) / 6.0) * 100) + '%'" stop-color="#f39c9d" />
                    <stop :offset="Math.round(((2.88) / 6.0) * 100) + '%'" stop-color="#8ed7da" />
                    <stop :offset="Math.round(((4.66) / 6.0) * 100) + '%'" stop-color="#8ed7da" />
                    <stop :offset="Math.round(((4.66) / 6.0) * 100) + '%'" stop-color="#a6e682" />
                    <stop :offset="Math.round(((5.50) / 6.0) * 100) + '%'" stop-color="#a6e682" />
                    <stop :offset="Math.round(((5.50) / 6.0) * 100) + '%'" stop-color="#62c829" />
                    <stop :offset="Math.round(((6.00) / 6.0) * 100) + '%'" stop-color="#62c829" />
                  </linearGradient>
                </defs>
                <g :transform="'translate(75 0)'">
                  <use xlink:href="#area" stroke-width="0" fill="#1ea0c2" opacity="0.1" stroke="none" vector-effect="non-scaling-stroke"/>
                  <path :d="getLine('uwes9', 'average')" stroke-width="3" fill="none" opacity="1" stroke="#1ea0c2" vector-effect="non-scaling-stroke"></path>
                </g>
                <g :transform="'translate(75 0)'">
                  <circle v-for="(point, index) in getPoints('uwes9', 'average')" :key="index" :cx="point.x" :cy="point.y" r="0.1" fill="#1ea0c2" stroke="#1ea0c2" stroke-width="5"  vector-effect="non-scaling-stroke"/>
                </g>
              </svg>
            </b-col>
            <b-col cols="12" md="5" order-md="1" class="pt-3">
              <h3 class="feedback-title">Work engagement during the past {{monthCount}} months. The higher and the thinner the area, the better.</h3>
            </b-col>
          </b-row> -->

          <!-- <b-row v-if="$parent.uwesTotalChange !== null" align-v="center" align-h="center" class="my-5">
            <b-col cols="12" sm="12" md="5" order-md="2">
              <div class="trend-indicator" :class="{'up': $parent.uwesTotalChange >= 0.77, 'down': $parent.uwesTotalChange <= -0.77, 'flat': Math.abs($parent.uwesTotalChange) < 0.77 }">
                <icon class="--icon" v-if="$parent.uwesTotalChange > 0" name="caret-up"/>
                <icon class="--icon" v-if="$parent.uwesTotalChange < 0" name="caret-down"/>
                <icon class="--icon" v-if="$parent.uwesTotalChange == 0" name="minus"/>
                <div class="--magnitude">
                  <span class="--value">{{Math.abs($parent.formatNumber0($parent.uwesTotalChange/6.0*100))}}</span>
                </div>
              </div>
              <div class="--reference-point">{{$t('personal-results:from')}} {{$parent.formatNumber0($parent.currentEngagementReport.previous.total.avg / 6 * 100)}} / 100 ({{$parent.currentEngagementReport.previous.total.updatedAt | moment('MMMM YYYY')}})</div>
            </b-col>
            <b-col cols="12" md="5" order-md="1">
              <h3 class="feedback-title">
                <span v-if="$parent.currentDirectionClass !== null">{{ $t('personal-results:total-direction-title-' + $parent.currentDirectionClass) }}</span><span v-if="$parent.uwesTotalChange !== 0 && $parent.currentEngagementReport.categories['uwes9-total'] === $parent.currentEngagementReport.previous.total.class">{{ $t('personal-results:total-class-same-' + $parent.currentEngagementReport.previous.total.class) }}</span>
                <span v-else-if="$parent.uwesTotalChange > 0 && $parent.currentEngagementReport.categories['uwes9-total'] !== $parent.currentEngagementReport.previous.total.class">
                  {{ $t('personal-results:total-class-level-up-' + $parent.currentEngagementReport.previous.total.class + '--' + $parent.currentEngagementReport.categories['uwes9-total']) }}
                </span>
                <span v-else-if="$parent.uwesTotalChange < 0 && $parent.currentEngagementReport.categories['uwes9-total'] !== $parent.currentEngagementReport.previous.total.class">
                  {{ $t('personal-results:total-class-level-down-' + $parent.currentEngagementReport.previous.total.class + '--' + $parent.currentEngagementReport.categories['uwes9-total']) }}
                </span>
              </h3>
            </b-col>
          </b-row>

          <b-row align-v="center" align-h="center" class="mt-2" v-if="$parent.hasDataForTotalComparison">
            <b-col cols="12" sm="12" md="5" order-md="2">
              <b-row>
                <b-col cols="12">
                  <div class="overall-score">
                    <span class="--value">{{$parent.formatNumber0($parent.currentCompanyEngagementReport.stats['uwes9-total'].avg/6.0*100)}}</span>
                    <span class="--scale">/ 100</span>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="animated-bar">
                    <div class="meter" :class="{'activated': $parent.companyUWESPercent !== 0}" :style="{'background-color': $parent.mapColor($parent.currentCompanyEngagementReport.categories['uwes9-total']), 'width': $parent.companyUWESPercent}"></div>
                  </div>
                  <p class="tidbit">{{$t('personal-results:current-average-of-team', {account: $store.state.account.name})}}, {{$t('common:updated')}} {{$parent.currentCompanyEngagementReport.updatedAt | moment('from')}}.</p>
                </b-col>
              </b-row>
              <b-button variant="outline-primary" size="sm" class="mb-3" to="/snapshot/engagement">{{$t('personal-results:full-team-report-cta')}}</b-button>
            </b-col>
            <b-col cols="12" md="5" order-md="1">
              <h3 class="feedback-title" v-if="$parent.getUWESDifferenceDegree() === 0">{{$t('personal-results:team-comparison-0')}}</h3>
              <h3 class="feedback-title" v-if="$parent.getUWESDifferenceDegree() > 0 && $parent.getPersonalTeamUWESDifference() < 0">{{$t('personal-results:team-comparison-below-' + $parent.getUWESDifferenceDegree())}}</h3>
              <h3 class="feedback-title" v-if="$parent.getUWESDifferenceDegree() > 0 && $parent.getPersonalTeamUWESDifference() > 0">{{$t('personal-results:team-comparison-above-' + $parent.getUWESDifferenceDegree())}}</h3>
              <p><b-btn v-b-toggle.collapse2 variant="link" size="sm"><icon name="regular/lightbulb" style="margin-right: 0.5em;"/> {{$t('common:well-being-not-a-competition')}}</b-btn></p>
            </b-col>
          </b-row> -->

          <!-- <b-row align-v="center" align-h="center" class="mb-3">
            <b-col cols="12" md="12">
              <div>
                <b-collapse id="collapse2" class="mt-0">
                  <b-card>
                    <p>{{$t('common:description-work-engagement-did-you-know')}}</p>
                  </b-card>
                </b-collapse>
              </div>
            </b-col>
          </b-row> -->
          <p class="tidbit text-center mt-5">{{$t('work-engagement-snapshot:report-response-info', { individualAnswers: $parent.currentEngagementReport.stats['uwes9-total'].individualAnswers, respondents: $parent.currentEngagementReport.stats['uwes9-total'].respondents })}}</p>
        </div>
      </b-container>

    </div>
  </report-layout>
</template>

<script>
import BarChart from '../../common/barchart/BarChart'
import ReportLayout from '../../layouts/ReportLayout'
export default {
  components: {
    barchart: BarChart,
    ReportLayout
  },
  mounted: function () {
    this.$parent.openedReport = 'engagement'
  },
  computed: {
    monthCount: function () {
      if (this.$parent.engagementHistory) {
        const months = Object.keys(this.$parent.engagementHistory)
        // const firstMonth = this.$moment(months[0])
        // const lastMonth = this.$moment(months[months.length - 1])
        // const numberOfMonths = lastMonth.diff(firstMonth, 'months')
        return months.length
      }
      return null
    }
  },
  methods: {
    getPoints: function (dimension, value) {
      const months = Object.keys(this.$parent.engagementHistory)
      const firstMonth = this.$moment(months[0])
      const lastMonth = this.$moment(months[months.length - 1])
      const numberOfMonths = lastMonth.diff(firstMonth, 'months')
      const points = []
      for (let i = 0; i <= numberOfMonths; i++) {
        const monthKey = firstMonth.clone().add(i, 'months').format('YYYY-MM')
        if (months.indexOf(monthKey) > -1 && this.$parent.engagementHistory[monthKey][dimension] && this.$parent.engagementHistory[monthKey][dimension][value]) {
          points.push({ x: 150 * i, y: 100 - this.$parent.engagementHistory[monthKey][dimension][value] / 6.0 * 100 })
        }
      }
      return points
    },
    getLine: function (dimension, value) {
      const months = Object.keys(this.$parent.engagementHistory)
      const firstMonth = this.$moment(months[0])
      const lastMonth = this.$moment(months[months.length - 1])
      const numberOfMonths = lastMonth.diff(firstMonth, 'months')
      let points = 'M'
      for (let i = 0; i <= numberOfMonths; i++) {
        const monthKey = firstMonth.clone().add(i, 'months').format('YYYY-MM')
        if (months.indexOf(monthKey) > -1 && this.$parent.engagementHistory[monthKey][dimension] && this.$parent.engagementHistory[monthKey][dimension][value]) {
          points += ` ${150 * i} ${100 - this.$parent.engagementHistory[monthKey][dimension][value] / 6.0 * 100}`
          if (i < numberOfMonths) {
            points += 'L'
          }
        }
      }
      return points
    },
    getMinMaxArea: function (dimension) {
      const months = Object.keys(this.$parent.engagementHistory)
      const firstMonth = this.$moment(months[0])
      const lastMonth = this.$moment(months[months.length - 1])
      const numberOfMonths = lastMonth.diff(firstMonth, 'months')
      let points = 'M'
      // LOOP TRHOUGH MAXIMUMS
      for (let i = 0; i <= numberOfMonths; i++) {
        const monthKey = firstMonth.clone().add(i, 'months').format('YYYY-MM')
        if (months.indexOf(monthKey) > -1 && this.$parent.engagementHistory[monthKey][dimension] && this.$parent.engagementHistory[monthKey][dimension].max) {
          points += ` ${150 * i} ${100 - this.$parent.engagementHistory[monthKey][dimension].max / 6.0 * 100}`
          // if (i < numberOfMonths) {
          //   points += 'L'
          // }
        }
      }
      // LOOP TRHOUGH MINIMUMS
      for (let i = numberOfMonths; i >= 0; i--) {
        const monthKey = firstMonth.clone().add(i, 'months').format('YYYY-MM')
        if (months.indexOf(monthKey) > -1 && this.$parent.engagementHistory[monthKey][dimension] && this.$parent.engagementHistory[monthKey][dimension].min) {
          points += ` ${150 * i} ${100 - this.$parent.engagementHistory[monthKey][dimension].min / 6.0 * 100}`
          if (i < numberOfMonths) {
            points += 'L'
          }
        }
      }
      return points
    }
  }
}
</script>
